<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="CT ParaOverride-5" id="_idParaDest-3"><span class="CharOverride-9">Copyright © 2003 by Aidan Hartley</span></p>
<p class="CRSpace">Cover design by Magan Wilson</p>
<p class="CRSpace">Cover artwork “Lazarus” (woman guerrilla with baby) by Aidan Hartley © Reuters Ltd.; press conference, courtesy of Catherine Bond; man, courtesy of Aidan Hartley; four men, courtesy of Kathy Eldon All other cover art and photography are from the collection of the author.</p>
<p class="CRSpace">All rights reserved. No part of this book may be reproduced in any form or by any electronic or mechanical means, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer, who may quote brief passages in a review. Scanning, uploading, and electronic distribution of this book or the facilitation of such without the permission of the publisher is prohibited. Please purchase only authorized electronic editions, and do not participate in or encourage electronic piracy of copyrighted materials. Your support of the author’s rights is appreciated. Any member of educational institutions wishing to photocopy part or all of the work for classroom use, or anthology, should send inquiries to Grove Atlantic, 154 West 14th Street, New York, NY 10011 or <a href="mailto:permissions@groveatlantic.com">permissions@groveatlantic.com</a>.</p>
<p class="CRSpace">Photo Credits: All chapter frontispiece photos courtesy of the Hartley family collection except: “Feeding the Beast” frontispiece photo by Jim Hollander; “The Sound of Freedom in the Air” frontispiece photo by Sam Ouma, courtesy Reuters; “Lazarus” frontispiece photo by Aidan Hartley, courtesy Reuters;“Herograms” frontispiece photo by Judy Walgren.</p>
<p class="CRSpace">Lyrics from “I Whistle A Happy Tune” by Richard Rodgers and Oscar Hammerstein II, copyright © 1951 by Richard Rodgers and Oscar Hammerstein II, copyright renewed. WILLIAMSON MUSIC owner of publication and allied rights throughout the World. International Copyright Secured. All Rights Reserved. Used by Permission.</p>
<p class="BT1stPara ParaOverride-6"><span class="CharOverride-10">Published simultaneously in Canada</span></p>
<p class="BT1stPara ParaOverride-4"><span class="CharOverride-10">Printed in the United States of America</span></p>
<p class="CRSpace">First hardcover edition published by Atlantic Monthly Press in 2003.</p>
<p class="CRSpace">First trade paperback edition published by Riverhead,an imprint of Penguin Random House, in 2004.</p>
<p class="CRSpace">ISBN 978-0-8021-2585-9</p>
<p class="CRSpace ParaOverride-7">eISBN 978-0-8021-8978-3</p>
<p class="CRSpace">Grove Press</p>
<p class="CR"><span class="CharOverride-11">an imprint of Grove Atlantic</span></p>
<p class="CR">154 West 14th Street</p>
<p class="CR">New York, NY  10011</p>
<p class="CR ParaOverride-8">Distributed by Publishers Group West</p>
<p class="CR ParaOverride-8"><a href="http://www.groveatlantic.com" target="_blank">groveatlantic.com</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eBook_V28912.vue?efdee712